/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PracticeArea {
  CorporateAndCommercial = "CorporateAndCommercial",
  DataPrivacyAndCybersecurity = "DataPrivacyAndCybersecurity",
  Energy = "Energy",
  Finance = "Finance",
  HealthcareAndLifeSciences = "HealthcareAndLifeSciences",
  IntellectualProperty = "IntellectualProperty",
  LaborAndEmployment = "LaborAndEmployment",
  LitigationAndDisputeResolution = "LitigationAndDisputeResolution",
  MergersAndAcquisitions = "MergersAndAcquisitions",
  RealEstate = "RealEstate",
  RegulatoryAndCompliance = "RegulatoryAndCompliance",
  Tax = "Tax",
  Technology = "Technology",
}

export const PracticeAreaDisplay: Record<PracticeArea, string> = {
  [PracticeArea.CorporateAndCommercial]: "Corporate & Commercial",
  [PracticeArea.DataPrivacyAndCybersecurity]: "Data Privacy & Cybersecurity",
  [PracticeArea.Energy]: "Energy Law",
  [PracticeArea.Finance]: "Finance & Capital Markets",
  [PracticeArea.HealthcareAndLifeSciences]: "Healthcare & Life Sciences",
  [PracticeArea.IntellectualProperty]: "Intellectual Property",
  [PracticeArea.LaborAndEmployment]: "Labor & Employment",
  [PracticeArea.LitigationAndDisputeResolution]: "Litigation",
  [PracticeArea.MergersAndAcquisitions]: "M&A & Divestitures",
  [PracticeArea.RealEstate]: "Real Estate",
  [PracticeArea.RegulatoryAndCompliance]: "Regulatory & Compliance",
  [PracticeArea.Tax]: "Tax Law",
  [PracticeArea.Technology]: "Technology & AI",
};
